/* eslint-disable */
import {IHttpClient} from '../api';
import {Location} from "@/domain/location";
import {AppConfig} from "@/utils/enums";

const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

export interface LocationResponse {
    locations: Location[];
}

export const LocationApi = (http: IHttpClient) => ({
    fetchAllLocations: () =>
        http.get<LocationResponse>(apiUrl + AppConfig.API_LOCATIONS_URL)
            .then(response => ({
            locations: response.data
        })),
    saveNewLocation: (newLocation: Location) =>
        http.post<Location>(apiUrl + AppConfig.API_LOCATIONS_URL, newLocation)
            .catch(error => {
                return error;
            }),
    updateLocation: (updatedLocation: Location) =>
        http.put<Location>(apiUrl + AppConfig.API_LOCATIONS_URL, updatedLocation)
            .catch(error => {
                return error;
            }),
    deleteLocation: (locationId: number) =>
        http.delete<number>(apiUrl + AppConfig.API_LOCATIONS_URL + '/' + locationId)
            .then(response => {
                return response;
            }).catch(error => error.response)
});
